import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

/**
 * @param userId {number}
 * @returns {Promise<{responseBody: *, status: number}>}
 */
const fetchCountriesDictionaryWithFollowing = (userId) => {
  const requestMethod = getAuthorizationToken()
    ? authorizedFetch
    : unauthorizedFetch;

  // @ts-ignore
  return requestMethod({
    method: REST_METHODS.GET,
    path: `/api/v1/profiles/users_filters/followings_location`,
    queryParams: [
      {
        name: 'user_id',
        value: userId,
      },
    ],
  });
};

export default fetchCountriesDictionaryWithFollowing;
